/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {createStore} from "redux";
import {layoutSession, notification, todoApp} from './reducers.jsx'


export const store = createStore(todoApp, window.STATE_FROM_SERVER);
// Log the initial state could come from a websocket
export const sessionStore = createStore(layoutSession, window.STATE_FROM_SERVER);// Log the initial state could come from a websocket

export const notificationStore = createStore(notification, window.STATE_FROM_SERVER);// Log the initial state could come from a websocket
